<template>
  <div class="building-info" :class="{'blank-t-v blank-b-v': !id, 'app-region blank-l-h blank-r-h': !isScan}">
    <!-- 初始化 -->
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" v-if="!id">
      <a-form-model-item label="楼栋名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入楼栋名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="单元数量" prop="numberOne">
        <a-input-number v-model="form.numberOne" placeholder="请输入单元数量" :min="0"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="楼层数量" prop="numberTwo">
        <a-input-number v-model="form.numberTwo" placeholder="请输入楼层数量" :min="0"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="起始楼层" prop="numberThree">
        <a-input-number v-model="form.numberThree" placeholder="请输入起始楼层" :min="0"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="每层户数" prop="numberFour">
        <a-input-number v-model="form.numberFour" placeholder="请输入每层户数" :min="0"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="房屋属性" prop="type">
        <a-select v-model="form.type" placeholder="请选择房屋属性">
          <a-select-option :value="1">住宅</a-select-option>
          <a-select-option :value="2">商住</a-select-option>
          <a-select-option :value="3">还迁</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="nextStep">下一步</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
    <!-- 列表 -->
    <a-row :gutter="64" type="flex" v-else>
      <a-col :span="24" :xl="6" class="divide">
        <div class="page-title">
          <a-space>{{name}}<a-icon type="edit" @click="rename({id, alias: name}, initBuildingName)" v-if="!isScan"></a-icon></a-space>
        </div>
        <a-spin tip="加载中..." :spinning="tree.loading">
          <a-tree class="list" block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :selected-keys="tree.selectedKeys">
            <template slot="title" slot-scope="row">
              <a-row type="flex">
                <a-col flex="1">{{row[tree.params.title]}}</a-col>
                <a-col v-if="!isScan">
                  <a-dropdown>
                    <a-icon type="ellipsis"></a-icon>
                    <a-menu slot="overlay">
                      <a-menu-item @click="resetUnit(row)">重置</a-menu-item>
                      <a-menu-item @click="cover(row, tree.data)">覆盖</a-menu-item>
                      <a-menu-item @click="disable(row)" v-if="row.is_enable">屏蔽</a-menu-item>
                      <a-menu-item @click="enable(row)" v-else>启用</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </a-col>
              </a-row>
            </template>
          </a-tree>
        </a-spin>
      </a-col>
      <a-col :span="24" :xl="18">
        <a-row type="flex" justify="end" align="middle" :gutter="[16, 16]" class="control" v-if="!isScan">
          <a-col>
            <a-tooltip title="批量设置房屋">
              <div class="batch" @click="batchDrawer.show = true">
                <dy-icon type="icon-batch"></dy-icon>
              </div>
            </a-tooltip>
          </a-col>
        </a-row>
        <a-spin tip="加载中..." :spinning="data.loading">
          <div class="wrap">
            <div class="list" v-for="(value, index) in data.floor" :key="value.id">
              <a-row type="flex" :gutter="[16, 16]">
                <a-col>
                  <div class="item floor w-auto" :class="{'disabled': !value.is_enable}">
                    <a-dropdown v-if="!isScan">
                      <a-space>{{value.alias}}<a-icon type="caret-down"></a-icon></a-space>
                      <a-menu slot="overlay">
                        <a-menu-item @click="addHouse(value)">新增房屋</a-menu-item>
                        <a-menu-item @click="rename(value, initFloorHouseData)">重命名</a-menu-item>
                        <a-menu-item @click="cover(value, data.floor)">覆盖</a-menu-item>
                        <a-menu-item @click="disable(value)" v-if="value.is_enable">屏蔽</a-menu-item>
                        <a-menu-item @click="enable(value)" v-else>启用</a-menu-item>
                      </a-menu>
                    </a-dropdown>
                    <a-space v-else>{{value.alias}}</a-space>
                  </div>
                </a-col>
                <a-col v-for="m in data.house[index]" :key="m.id" @click="houseInfo(m)">
                  <div class="item house" :class="{'disabled': !m.is_enable}">
                    <a-row type="flex" justify="space-between" align="middle">
                      <a-col>{{m.alias}}</a-col>
                      <a-col v-if="!isScan">
                        <a-dropdown>
                          <a-icon type="ellipsis"></a-icon>
                          <a-menu slot="overlay">
                            <a-menu-item @click="rename(m, initFloorHouseData)">重命名</a-menu-item>
                            <a-menu-item @click="disableHouse([m])" v-if="m.is_enable">屏蔽</a-menu-item>
                            <a-menu-item @click="enableHouse([m])" v-else>启用</a-menu-item>
                          </a-menu>
                        </a-dropdown>
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between" align="middle">
                      <a-col flex="1">
                        <a-dropdown v-if="!isScan">
                          <a-tag class="empty" v-if="!m.housing_type">设置户型</a-tag>
                          <a-tag color="blue" v-else>{{m.housing_type.name}}</a-tag>
                          <a-menu slot="overlay">
                            <a-menu-item v-for="x in data.houseType" :key="x.id" @click="setHouseType(x, [m])">{{x.name}}</a-menu-item>
                          </a-menu>
                        </a-dropdown>
                        <template v-else>
                          <a-tag color="orange">{{m.houseTypeText}}</a-tag>
                          <a-tag color="green">{{m.houseStatusText}}</a-tag>
                        </template>
                      </a-col>
                    </a-row>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-spin>
      </a-col>
    </a-row>
    <!-- 重命名 -->
    <a-modal :title="modalOne.title" :confirm-loading="modalOne.loading" v-model="modalOne.show" @ok="confirmModalOne" destroy-on-close centered>
      <a-form-model ref="modalOneForm" :model="modalOne.form" layout="vertical" :rules="modalOne.rules">
        <a-form-model-item label="旧名称" prop="oldName">
          <a-input v-model="modalOne.form.oldName" placeholder="请输入旧名称" allow-clear disabled></a-input>
        </a-form-model-item>
        <a-form-model-item label="新名称" prop="newName">
          <a-input v-model="modalOne.form.newName" placeholder="请输入新名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 覆盖 -->
    <a-modal :title="modalTwo.title" :confirm-loading="modalTwo.loading" v-model="modalTwo.show" @ok="confirmModalTwo" destroy-on-close centered>
      <a-form-model ref="modalTwoForm" :model="modalTwo.form" layout="vertical" :rules="modalTwo.rules">
        <a-form-model-item :label="`将${modalTwo.name}覆盖到`" prop="data">
          <a-select v-model="modalTwo.form.data" placeholder="请选择" mode="multiple">
            <a-select-option :value="value.id" :key="value.id" v-for="value in modalTwo.options">{{value.alias}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 房屋详情 -->
    <a-drawer width="70%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <house-info :id="drawer.id"></house-info>
    </a-drawer>
    <!-- 批量设置 -->
    <a-drawer width="70%" :title="batchDrawer.title" :visible="batchDrawer.show" destroy-on-close @close="batchDrawer.show = false" :afterVisibleChange="switchBatchDrawer">
      <a-space class="mg-normal">
        <a-dropdown>
          <a-button type="primary">设置户型<a-icon type="down"></a-icon></a-button>
          <a-menu slot="overlay">
            <a-menu-item v-for="x in data.houseType" :key="x.id" @click="setHouseType(x, batchDrawer.house)">{{x.name}}</a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-button type="primary" @click="disableHouse(batchDrawer.house)">屏蔽房屋</a-button>
        <a-button type="primary" @click="enableHouse(batchDrawer.house)">开启房屋</a-button>
        <a-button type="primary" @click="batchDrawer.house = []">清空选中房屋</a-button>
      </a-space>
      <batch-select-house :init-data="data.house" v-model="batchDrawer.house" class="mg-normal"></batch-select-house>
    </a-drawer>
  </div>
</template>

<script>
  import {
    houseTypeText,
    houseStatusText
  } from '@/io/dict.js';
  import HouseTypeService from '@/io/house_type.js';
  import BuildingService from '@/io/building.js';
  import HouseInfo from '@/views/community/HouseInfo.vue';
  
  export default {
    name: 'BuildingInfo',
    props: {
      isScan: {
        type: Boolean,
        default: false
      },
      initId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        communityId: this.$route.query.community_id,
        id: this.$route.params.id,
        form: {
          name: null,
          numberOne: null,
          numberTwo: null,
          numberThree: null,
          numberFour: null,
          type: []
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入楼栋名称'
            }
          ],
          numberOne: [
            {
              required: true,
              message: '请输入单元数量'
            }
          ],
          numberTwo: [
            {
              required: true,
              message: '请输入楼层数量'
            }
          ],
          numberThree: [
            {
              required: true,
              message: '请输入起始楼层'
            }
          ],
          numberFour: [
            {
              required: true,
              message: '请输入每层户数'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择房屋属性'
            }
          ]
        },
        name: null,
        tree: {
          selectedKeys: [],
          keyword: null,
          loading: false,
          data: [],
          searchData: [],
          params: {
            children: 'children',
            title: 'alias',
            key: 'id'
          }
        },
        data: {
          loading: false,
          floor: [],
          house: [],
          column: [],
          houseType: []
        },
        modalOne: {
          id: null,
          callback: () => {},
          title: '重命名',
          show: false,
          loading: false,
          form: {
            oldName: null,
            newName: null
          },
          rules: {
            newName: [
              {
                required: true,
                message: '请填写新名称'
              }
            ]
          }
        },
        modalTwo: {
          id: null,
          name: null,
          options: [],
          title: '覆盖',
          show: false,
          loading: false,
          form: {
            data: []
          },
          rules: {
            data: [
              {
                required: true,
                message: '请选择'
              }
            ]
          }
        },
        drawer: {
          id: null,
          title: '房屋详情',
          show: false
        },
        batchDrawer: {
          house: [],
          title: '批量设置房屋',
          show: false
        }
      }
    },
    watch: {
      initId: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.id = newValue;
          }
        },
        immediate: true
      },
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initBuildingName();
            if (!this.isScan) {
              this.initHouseTypeData();
            }
            this.initTreeData().then(() => {
              this.selectTreeNode([this.tree.data[0][this.tree.params.key]]);
            });
          }
        },
        immediate: true
      }
    },
    components: {
      HouseInfo,
    },
    methods: {
      switchBatchDrawer(visible) {
        if (!visible) {
          this.batchDrawer.house = [];
          this.initTreeData();
          this.initFloorHouseData();
        }
      },
      houseInfo(data) {
        this.drawer.id = data.id;
        this.drawer.show = true;
      },
      cover(data, source) {
        this.modalTwo.id = data.id;
        this.modalTwo.name = data.alias;
        this.modalTwo.options = source;
        this.modalTwo.form.data = [];
        this.modalTwo.show = true;
      },
      confirmModalTwo() {
        this.$beforeFormSubmit(this.$refs.modalTwoForm, () => {
          this.modalTwo.loading = true;
          BuildingService.cover(this.modalTwo.id, this.modalTwo.form.data).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.initTreeData();
              this.initFloorHouseData();
            });
          }).catch(err => {}).finally(() => {
            this.modalTwo.show = false;
            this.modalTwo.loading = false;
          });
        });
      },
      enable(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: `确认启用${data.alias}？`,
          onOk() {
            BuildingService.enable(data.id).then(res => {
              self.initTreeData();
              self.initFloorHouseData();
            }).catch(err => {});
          }
        });
      },
      disable(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: `确认屏蔽${data.alias}？`,
          onOk() {
            BuildingService.disable(data.id).then(res => {
              self.initTreeData();
              self.initFloorHouseData();
            }).catch(err => {});
          }
        });
      },
      enableHouse(data) {
        if (data.length) {
          let self = this;
          this.$confirm({
            title: '提示',
            content: `确认启用${data.map(val => val.alias).join('、')}？`,
            onOk() {
              BuildingService.enableHouse(data.map(val => val.id)).then(res => {
                self.$message.success('成功启用房屋');
                if (!self.batchDrawer.show) {
                  self.initFloorHouseData();
                }
              }).catch(err => {});
            }
          });
        } else {
          this.$message.error('请选择房屋');
        }
      },
      disableHouse(data) {
        if (data.length) {
          let self = this;
          this.$confirm({
            title: '提示',
            content: `确认屏蔽${data.map(val => val.alias).join('、')}？`,
            onOk() {
              BuildingService.disableHouse(data.map(val => val.id)).then(res => {
                self.$message.success('成功屏蔽房屋');
                if (!self.batchDrawer.show) {
                  self.initFloorHouseData();
                }
              }).catch(err => {});
            }
          });
        } else {
          this.$message.error('请选择房屋');
        }
      },
      setHouseType(houseType, house) {
        if (house.length) {
          BuildingService.batchSetHouseType(houseType.id, house.map(val => val.id)).then(() => {
            this.$message.success('成功设置户型');
            if (!this.batchDrawer.show) {
                this.initFloorHouseData();
              }
          }).catch(err => {});
        } else {
          this.$message.error('请选择房屋');
        }
      },
      rename(data, callback) {
        this.modalOne.id = data.id;
        this.modalOne.form.oldName = data.alias;
        this.modalOne.form.newName = null;
        this.modalOne.show = true;
        this.modalOne.callback = callback;
      },
      confirmModalOne() {
        this.$beforeFormSubmit(this.$refs.modalOneForm, () => {
          this.modalOne.loading = true;
          BuildingService.rename(this.modalOne.id, this.modalOne.form.newName).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.modalOne.callback();
            });
          }).catch(err => {}).finally(() => {
            this.modalOne.show = false;
            this.modalOne.loading = false;
          });
        });
      },
      resetUnit(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: `确认重置${data.alias}？`,
          onOk() {
            BuildingService.resetUnit(data.id).then(res => {
              self.initFloorHouseData();
            }).catch(err => {});
          }
        });
      },
      addHouse(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: `确认在${data.alias}新增一个房屋？`,
          onOk() {
            let name = data.children[data.children.length - 1].initial_name * 1 + 1;
            BuildingService.addHouse(data.id, name).then(res => {
              self.initFloorHouseData();
            }).catch(err => {});
          }
        });
      },
      selectTreeNode(selectedKeys) {
        if (selectedKeys.length) {
          this.tree.selectedKeys = selectedKeys;
          this.initFloorHouseData();
        }
      },
      initHouseTypeData() {
        HouseTypeService.listPage(this.communityId).then(res => {
          this.data.houseType = res;
        }).catch(err => {});
      },
      initBuildingName() {
        BuildingService.info(this.id).then(res => {
          this.name = res.alias;
        }).catch(err => {});
      },
      initTreeData() {
        this.tree.loading = true;
        return BuildingService.unitList(this.id).then(res => {
          this.tree.data = res.map(val => {
            if (!val.is_enable) {
              val.alias += '(屏蔽)';
            }
            val.scopedSlots = {
              title: 'title'
            };
            return val;
          });
        }).catch(err => {}).finally(() => {
          this.tree.loading = false;
        });
      },
      initFloorHouseData() {
        this.data.loading = true;
        this.data.floor = [];
        this.data.house = [];
        this.data.column = [];
        BuildingService.floorHouseList(this.tree.selectedKeys[0]).then(res => {
          let floor = [];
          let house = [];
          let column = 0;
          res.forEach(val => {
            floor.push(val);
            house.push(val.children.map(m => {
              m.houseTypeText = houseTypeText(m.house_state),
              m.houseStatusText = houseStatusText(m.state)
              return m;
            }));
          });
          this.data.floor = floor;
          this.data.house = house;
        }).catch(err => {}).finally(() => {
          this.data.loading = false;
        });
      },
      nextStep() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          BuildingService.add(
            this.communityId,
            this.form.name,
            this.form.numberOne,
            this.form.numberTwo,
            this.form.numberThree,
            this.form.numberFour,
            this.form.type
          ).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.id = res[0].id;
            });
          }).catch(err => {});
        });
      },
      cancel() {
        this.$router.push({
          name: 'BuildingManage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .building-info {
    .control {
      padding-top: @padding-lg;
      .batch {
        width: 32px;
        height: 32px;
        border: 1px solid @border-color-base;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: @font-size-lg;
        cursor: pointer;
        transition: all @animation-duration-base;
        &:hover {
          background-color: @primary-color;
          border-color: @primary-color;
          color: @white;
        }
      }
    }
    .wrap {
      padding: @padding-lg 0;
      overflow: auto;
      .list {
        padding: @padding-xs 0;
        & > .ant-row-flex {
          flex-wrap: nowrap;
          & > .ant-col {
            .item {
              width: 200px;
              height: 90px;
              min-width: 80px;
              min-height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: @padding-md;
              flex-wrap: wrap;
              &.disabled {
                opacity: .6;
              }
              &.w-auto {
                width: auto;
                padding: 0;
              }
              &.h-auto {
                height: auto;
                padding: 0;
              }
              &.floor {
                font-size: @font-size-xl;
                font-weight: bold;
              }
              &.house {
                background-color: @background-color-base;
                transition: all @animation-duration-base;
                cursor: pointer;
                &:hover {
                  background-color: @primary-color;
                  color: @white;
                }
                & > .ant-row-flex {
                  width: 100%;
                  &:nth-of-type(1) {
                    font-size: @font-size-xl;
                    font-weight: bold;
                    margin-bottom: @padding-xs;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>